import React, { useState,useEffect } from 'react';
import Wrapper from './styles';
import { formatPrice } from '../../utils/helpers';
import ReviewModal from "../../components/ReviewModal"
import { useProductsContext } from '../../context/products_context';

const OrderItem = ({
  name,
  price,
  quantity,
  image,
  color,
  size,
  product,
  orderStatus,
  shippingInfo,
  paymentStatus
}) => {
  const [review,setReview]=useState("")
  const [isAddReview, setIsAddReview]=useState(false)
  const {products}=useProductsContext()
  const [selectedProduct, setSelectedProduct]=useState(null)
  useEffect(()=>{
    if(products){
      setSelectedProduct(products?.find((e) => e?.id === product));
    }

  },[products])
  return (
    <div className='w-full flex-col gap-3'>
      <div className='w-full flex flex-col md:flex-row justify-between items-center gap-3 p-4'>
        <img
          src={Array.isArray(image) ? image[0] : image}
          alt={name}
          className='h-32 w-32 rounded-md'
        />
        <div className='flex flex-col gap-3'>
          <h1 className='font-semibold text-lg'>{name}</h1>
          <div className='flex flex-col lg:flex gap-2 '>
            <p>Order Status:</p>
            <h1 className='font-semibold text-sm text-[green]'>
              {orderStatus}
            </h1>
          </div>
          <div className='flex flex-col lg:flex gap-2'>
            <p>Payment Status:</p>
            <h1 className='font-semibold text-sm text-[green]'>
              {paymentStatus}
            </h1>
          </div>
          <p>Quantity: {quantity}</p>
          <button
            className='rounded-lg p-1 text-white border border-[#d3a143]'
            style={{ color: '#d3a143', backgroundColor: 'white' }}
            onClick={() => {
              setIsAddReview((prev) => !prev);
            }}
          >
            Write Review
          </button>
        </div>
        <div className='flex flex-col gap-3 text-center'>
          <p>{shippingInfo?.address}</p>
          <p>{shippingInfo?.city}</p>
          <p>{shippingInfo?.state}</p>
          <p>{shippingInfo?.country}</p>
          <p>{shippingInfo?.pinCode}</p>
          <p>{shippingInfo?.phoneNumber}</p>
        </div>
        <div>
          {/* <button
            className='rounded-lg p-2 text-white'
            style={{ backgroundColor: '#d3a143' }}
            onClick={() => {}}
          >
            Track order
          </button> */}
        </div>
      </div>
      {isAddReview && (
        <div className='bg-[#DBDBDB] p-6 rounded-md flex flex-col gap-4 m-2'>
          <ReviewModal product={product} setIsAddReview ={setIsAddReview}/>
        </div>
      )}
    </div>
  );
};

export default OrderItem;
